import { Entity, Field } from "typegraph";

@Entity({one: "", many: "tagSets"})
export default class TagSet {

	@Field()
	public id: string;

	@Field()
	public name: string;

	@Field()
	public sortIndex: number;

}



// WEBPACK FOOTER //
// ./src/panels/refineTag/entities/TagSet.ts